module.exports = __webpack_public_path__ + "img/icon_set_2.a5c4d81f.svg";